/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TroopOutcomeDtoPaginationResponseResponse } from '../models/TroopOutcomeDtoPaginationResponseResponse';
import type { TroopOutcomeDtoResponse } from '../models/TroopOutcomeDtoResponse';
import type { UpdateTroopOutcomeCommand } from '../models/UpdateTroopOutcomeCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TroopOutcomeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param sedationistId
     * @param pageNo
     * @param pageSize
     * @returns TroopOutcomeDtoPaginationResponseResponse Success
     * @throws ApiError
     */
    public getApiTroopOutcomeTroopOutcomes(
        sedationistId: string,
        pageNo?: number,
        pageSize?: number,
    ): CancelablePromise<TroopOutcomeDtoPaginationResponseResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/TroopOutcome/TroopOutcomes',
            query: {
                'SedationistId': sedationistId,
                'PageNo': pageNo,
                'PageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param pageNo
     * @param pageSize
     * @returns TroopOutcomeDtoPaginationResponseResponse Success
     * @throws ApiError
     */
    public getApiTroopOutcomeAllTroopOutcomes(
        pageNo?: number,
        pageSize?: number,
    ): CancelablePromise<TroopOutcomeDtoPaginationResponseResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/TroopOutcome/AllTroopOutcomes',
            query: {
                'PageNo': pageNo,
                'PageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns TroopOutcomeDtoResponse Success
     * @throws ApiError
     */
    public putApiTroopOutcomeUpdateTroopOutcome(
        requestBody?: UpdateTroopOutcomeCommand,
    ): CancelablePromise<TroopOutcomeDtoResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/TroopOutcome/UpdateTroopOutcome',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
